import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';

import { getGamesQueryOptions } from '@/api/getGames';

import { authLoader, publicLoader } from '../authentication/authLoader';
import { queryClient } from '../lib/react-query';
import ErrorPage from './routes/error-page';
import { gameRoute } from './routes/game/route';
import Root from './routes/root';

// Created on first render, not at import time: createBrowserRouter() calls
// .initialize() straight away, which runs the matched route's loaders. At import time
// that beats msw's worker.start(), so the mock handlers would miss the first requests.
// Memoised outside React so StrictMode's double render reuses the same router.
let cachedRouter: ReturnType<typeof createBrowserRouter> | undefined;

const createRouter = () =>
  createBrowserRouter([
    {
      path: '/',
      id: 'root',
      element: <Root />,
      loader: authLoader,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          loader: () => redirect('/game'),
        },
        {
          path: 'login',
          loader: publicLoader,
          lazy: () => import('@/app/routes/auth/login'),
          children: [
            {
              path: 'login-form',
              lazy: () => import('@/app/routes/auth/login-form'),
            },
            {
              path: 'sso-microsoft',
              lazy: () => import('@/app/routes/auth/sso-microsoft'),
            },
          ],
        },
        {
          path: 'logout',
          lazy: () => import('@/app/routes/auth/logout'),
        },
        {
          path: 'game',
          loader: () => queryClient.ensureQueryData(getGamesQueryOptions()),
          lazy: () => import('@/app/routes/game/gameList'),
        },
        { ...gameRoute(queryClient) },
      ],
    },
  ]);

export const AppRouter = () => {
  cachedRouter ??= createRouter();

  return <RouterProvider router={cachedRouter} />;
};
